import { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import DashboardContainer from '../DashboardContainer';
import ErrorBoundary from '../../components/ErrorBoundary';
import { loadingChunkRetry } from '../../helpers/utils';
import PreviewComponent from './PreviewComponent';

const Timesheet = lazy(() => loadingChunkRetry(() => import('./Timesheet')));

const TimesheetContainer = (props) => {
  return (
    <DashboardContainer>
      <Helmet>
        <title>{`${props.timesheet.data?.description || 'Timesheet'} | Sage Intelligent Time`}</title>
      </Helmet>
      <ErrorBoundary>
        <Suspense fallback={<PreviewComponent />}>
          <Timesheet />
        </Suspense>
      </ErrorBoundary>
    </DashboardContainer>
  );
};

const mapStateToProps = (state) => ({
  timesheet: state.timesheet,
});

export default connect(mapStateToProps, null)(TimesheetContainer);
